import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import LinearProgress from '@material-ui/core/LinearProgress'
import TopNavigationAppShell from './top-navigation-app-shell'
import * as pageTextActions from '../store/page-texts'
import ReactMarkdown from 'react-markdown'
import Styles from './styles'

const mapStateToProps = state => ({
  pageTexts: state.pageTexts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  pageTextActions: bindActionCreators(pageTextActions, dispatch)
})

class PrivacyPolicyPage extends Component {
  componentDidMount () {
    this.props.pageTextActions.getPageText('PrivacyPolicyPage', this.props.locales.country, this.props.locales.language)
  }

  render () {
    const { pageTexts, classes } = this.props
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.topNavContent}>
            <Paper elevation={3} square style={{ marginTop: '20px', marginBottom: '20px' }}>
              {pageTexts.loading && <LinearProgress />}
              <div className={classes.content}>
                <ReactMarkdown source={pageTexts.item.content} />
              </div>
            </Paper>
          </div>
        }
        pageName={'Privacy Policy'}
      />
    )
  }
}

PrivacyPolicyPage = connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyPage)
export default withStyles(Styles)(PrivacyPolicyPage)



// WEBPACK FOOTER //
// ./src/common/privacy-policy-page.js